import React from 'react'

import Icon from '@/components/common/Icon'

const IconPickup: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 42 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-0.000244141 32L0.999756 28H11.9998L10.9998 32H-0.000244141ZM3.99976 24L4.99976 20H17.9998L16.9998 24H3.99976ZM35.1498 36L36.1498 28L37.5998 16L38.0998 12.05L35.1498 36ZM9.99976 40C8.89976 40 7.95809 39.6083 7.17476 38.825C6.39142 38.0417 5.99976 37.1 5.99976 36H35.1498L38.0998 12.05H32.5998L32.0498 16.3C31.9831 16.8667 31.7331 17.3083 31.2998 17.625C30.8664 17.9417 30.3664 18.0667 29.7998 18C29.2331 17.9333 28.7914 17.6917 28.4748 17.275C28.1581 16.8583 28.0331 16.3667 28.0998 15.8L28.5498 12.05H20.5998L20.0498 16.25C19.9831 16.8167 19.7331 17.2667 19.2998 17.6C18.8664 17.9333 18.3664 18.0667 17.7998 18C17.2331 17.9333 16.7831 17.6833 16.4498 17.25C16.1164 16.8167 15.9831 16.3167 16.0498 15.75L16.4998 12.05H8.99976C9.13309 10.9167 9.56643 9.95834 10.2998 9.175C11.0331 8.39167 11.9331 8 12.9998 8H16.9998C17.2664 5.5 18.1248 3.54167 19.5748 2.125C21.0248 0.708333 22.9998 0 25.4998 0C27.6331 0 29.4081 0.791667 30.8248 2.375C32.2414 3.95833 32.9331 5.83333 32.8998 8H37.9998C39.1998 8.03334 40.1998 8.5 40.9998 9.4C41.7998 10.3 42.1164 11.35 41.9498 12.55L38.9498 36.55C38.8164 37.55 38.3748 38.375 37.6248 39.025C36.8748 39.675 35.9998 40 34.9998 40H9.99976ZM20.9998 8H28.9498C28.9831 6.9 28.6081 5.95833 27.8248 5.175C27.0414 4.39167 26.0998 4 24.9998 4C23.8331 4 22.9081 4.35833 22.2248 5.075C21.5414 5.79167 21.1331 6.76667 20.9998 8Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon(IconPickup)
